// import { processRequest } from '@iez/lib'
import getMutation from './get-mutation/'
import getVariables from './get-variables/'
import getOptimisticResponse from './get-optimistic-response/'
// import getUpdate from './get-update/'
// import { DateTime } from 'luxon'
// import { mergeDeep } from '@apollo/client/utilities/common/mergeDeep'
// import { print } from 'graphql/language/printer'
import { getClient } from '..'
import get from '../get/'
import toGraphql from '@iez/lib/to-graphql/'
import gql from 'graphql-tag'

export default async ({ root, items, fields, realtime, one, parents=[] }) => {
  const client = getClient()
  const mutation = getMutation({ root, fields })
  const variables = getVariables({ items })
  const optimisticResponse = getOptimisticResponse({ root, items, fields })
  // const update = patches
  //   ? getUpdate({ root, fields, request, mutationId }).patch
  //   : getUpdate({ root, fields, request , mutationId }).insert
  // state.result = patches
  //   ? state.result
  //     .map((item, i) =>
  //       patches[i]
  //       ? mergeDeep(item, patches[i])
  //       : item)
  //   : [
  //     ...state.result,
  //     ...items.map(item => ({
  //       ...item,
  //       mutationId
  //     }))
  //   ]
  
  const update = (cache, { data }) => {
    parents.forEach(({ root: parentRoot, id: parentId, field }) => {
      cache.modify({
        ...parentId
          ? ({
            id: `${parentRoot}:${parentId}`
          }) : null,
        fields: {
          [field || root]: (existing = []) => {
            const newRef = cache.writeFragment({
              data: data[`insert_${root}`].returning[0],
              fragment: gql`
                fragment NewRef on ${root} {
                  ${toGraphql(fields)}
                }
              `
            })
            return [
              newRef,
              ...existing
            ]
          }
        }
      })
    })
    cache.modify({
      fields: {
        [root]: (existing = []) => {
          const newRef = cache.writeFragment({
            data: data[`insert_${root}`].returning[0],
            fragment: gql`
              fragment NewRef on ${root} {
                ${toGraphql(fields)}
              }
            `
          })
          return [
            newRef,
            ...existing
          ]
        }
      }
    })
  }
  const payload = await client.mutate({
    mutation,
    variables,
    update
    // optimisticResponse
  }).catch(error => {
    console.error('nope', error.message)
  })

  const data = payload.data[`insert_${root}`].returning

  return realtime
    ? get({
      root,
      fields,
      request: {
        where: {
          id: {
            _in: data.map(({ id }) => id)
          }
        }
      },
      realtime,
      one
    }) : one
      ? data[0]
      : data
}
